import { getMessages, getMessagesOnDashboard, messageRead, getMessageConfig, updateMessageConfig } from "@/api/message/message";
import { Message } from 'view-design';
import moment from "moment";

const pageSize = 10;

export default {
    namespaced: true,
    state: {
        messages: [],
        messageOnDashboard: [],
        config: null,
        showUnread: false,
        
        total: -1,
        unreadTotal: 0,
        loading: false,
    },
    getters: {
        // messageOnDashboard: state => state.messagesOnDashboard, //state.messages ? state.messages.filter(m => m.indexNotif && m.indexNotif >= moment().add(1, 'day').startOf('day')) : [],
        unreadMessages: state => state.messages ? state.messages.filter(m => m.status === 'UNREAD') : [],
    },
    mutations: {
        // reset
        resetMsgs(state) {
            state.messages = [];
            state.total = -1;
            state.unreadTotal = 0;
            // state.messageOnDashboard = [];
            state.showUnread = false;
        },
        resetMsgList(state) {
            state.messages = [];
            state.total = -1;
            state.unreadTotal = 0;
        },

        // state control
        toggleShowUnread(state) {
            if (state.showUnread)
                state.showUnread = false;
            else if (state.unreadTotal > 0)
                state.showUnread = true;
        },

        // get
        setMessages(state, payload) {
            state.total = payload.total;
            state.unreadTotal = payload.unreadTotal;
            Array.prototype.push.apply(state.messages, payload.messages);
            // state.messages = payload.messages;
            state.messages.sort((a, b) => b.timestamp - a.timestamp);
        },
        setMessagesOnDashboard(state, messages) {
            state.messageOnDashboard = messages;
            state.messageOnDashboard.sort((a, b) => a.timestamp - b.timestamp);
        },

        setMessageRead(state, payload) {
            payload.messages.forEach(message => {
                message.status = 'READ';
                state.messages.splice(state.messages.indexOf(message), 1, message);
            });
            state.unreadTotal = payload.unreadTotal;
            // if (state.unreadTotal === 0)
            //     state.showUnread = false;
        },

        // config
        setConfig(state, payload) {
            state.config = payload;
            // state.savedConfig = {};
            // Object.keys(payload).forEach(k => {
            //     state.config[k] = payload[k];
            //     state.savedConfig[k] = payload[k];
            // });
        },

        // loading
        setLoading(state) {
            state.loading = true;
        },
        resetLoading(state) {
            state.loading = false;
        }
    },
    actions: {
        // reset
        resetMsgs({ commit }) {
            commit('resetMsgs');
        },

        // state control
        toggleShowUnread({ commit, dispatch }) {
            commit('toggleShowUnread');
            commit('resetMsgList');
            dispatch("getMsgs");
        },

        // get
        async getMsgs({ commit, state, rootState }) {
            if (!rootState.token) return;
            if (state.total >= 0 && state.messages.length >= state.total) return;
            if (state.loading) return;
            // 后端排序按照时间轴方式
            try {
                commit("setLoading");
                const res = await getMessages({ pageSize, pageNumber: parseInt(state.messages.length / pageSize) + 1, unread: state.showUnread });
                if (res) commit("setMessages", res);
                else throw res;
            } catch (e) {
                console.error(e);
                // Message.error('获取消息失败');
            } finally {
                commit("resetLoading");
            }
        },
        async getMsgsOnDashboard({ commit, state, rootState }) {
            if (!rootState.token) return;
            try {
                const res = await getMessagesOnDashboard();
                if (res) commit("setMessagesOnDashboard", res);
                else throw res;
            } catch (e) {
                console.error(e);
            }
        },
        async msgRead({ commit, state, dispatch }, msgs) {
            try {
                const res = await messageRead(msgs.map(m => m.id));
                if (res) {
                    commit("setMessageRead", {
                        messages: msgs,
                        unreadTotal: res.unreadTotal
                    });
                    if (state.showUnread) {
                        if (state.unreadTotal === 0) dispatch('toggleShowUnread');
                        else {
                            commit('resetMsgList');
                            dispatch("getMsgs");
                        }
                    }   
                } else throw res;
            } catch (e) {
                console.error(e);
                Message.error('设置消息已读失败');
            }
        },
        async getMsgConfig({ commit }) {
            try {
                const res = await getMessageConfig();
                if (res)
                    commit('setConfig', res);
                else
                    throw res;
            } catch (e) {
                console.error(e);
                commit('setConfig', {});
                Message.error('出错啦');
            }
        },
        async updateMsgConfig({ commit }, payload) {
            try {
                const res = await updateMessageConfig(payload);
                if (res) {
                    commit('setConfig', res);
                    Message.success('操作成功！');
                } else
                    throw res;
            } catch (e) {
                console.error(e);
                // Message.error('更新推送设置出错');
            }
        },
    },
};
